import { css } from 'styled-components'


const jsStyles = {
    flexRow: () => css`${
        props => props.displayType === 'horizontal' ? `
        display: flex;
        width: 100%;
        flex-direction: row;
        ` : `
        display: flex; 
        flex-direction: column;
        `
    }`,
}

export default jsStyles